import type { ReactNode } from 'react';
import './Tabs.css';

interface TabsProps {
  tabs: string[];
  activeTab: number;
  onClickTab: (index: number) => void;
  children?: ReactNode;
}

export default function Tabs({
  tabs,
  activeTab,
  onClickTab,
  children
}: TabsProps) {
  return (
    <>
      <div role="tablist">
        {tabs.map((label, index) => (
          <button
            key={index}
            aria-selected={index === activeTab}
            role="tab"
            onClick={() => onClickTab(index)}
          >
            {label}
          </button>
        ))}
      </div>
      <div role="tabpanel">{children}</div>
    </>
  );
}
